export default {
	termsAndConditions: {
		lastUpdate: 'Viimeksi päivitetty: 10. kesäkuuta 2024',
		content: `
		<p>Alla olevat ehdot ovat tärkeitä, koska:</p>
		<ul>
			<li>He perustavat lailliset oikeutensa sivustolle {siteName}.</li>
			<li>Selitä oikeudet, jotka annat meille käyttäessäsi sivustoa {siteName}.</li>
			<li>
				Niissä kuvataan säännöt, joita kaikkien on noudatettava käytettäessä {siteName}.
			</li>
		</ul>
		<p>
			Lue nämä ehdot huolellisesti, samoin kuin {privacyPolicyLink} ja muut
			näissä ehdoissa mainitut asiakirjat.
		</p>
		<p>Aloitetaan...</p>
		<h3>1. SIVUN {siteNameUpper} JOHDANTO JA TIEDOT.</h3>
		<p>
			Verkkosivusto {websiteLink} (jäljempänä "verkkosivusto") on yrityksen omistama
			{siteName} S.L (jäljempänä "{siteName}"), yritys
			perustettu Espanjan lainsäädännön mukaisesti ja osoite Avenida de
			Cerdanyola, nº 75, 1º, Sant Cugat del Vallès (Barcelona), CIF-numeron haltija
			B-56.768.260 ja rekisteröity Barcelonan Mercantile Registry -rekisteriin Volumessa
			49065, Folio 0033, Arkki B-606324, 1. rekisteröinti.
		</p>
		<p>
			{siteName} antaa verkkosivuston käyttöösi, jotta pääset sinne
			tunne meidät paremmin, tunne tarjoamamme palvelut ja voit halutessasi ottaa yhteyttä
			ja tarvittaessa tehdä sopimus kanssamme.
		</p>
		<h3>2. KÄYTTÖEHTOJEN TARKOITUS JA SOVELTAMISALA</h3>
		<p>
			Nämä käyttöehdot muodostavat yhdessä {privacyPolicyLink}:n ja
			{cookiesPolicyLink}, oikeudellinen kehys, joka säätelee verkkosivuston käyttöä
			{websiteLink}. Nämä käyttöehdot ovat saatavillasi verkkosivustolla
			englanniksi, jotta voit tarkastella, arkistoida tai tulostaa niitä milloin tahansa ja
			milloin vain haluat.
		</p>
		<p>
			Tietääksesi kaikki kysymykset, jotka koskevat {siteName}:n suorittamaa hoitoa.
			henkilötiedoistasi, käy osoitteessa {privacyPolicyLink} ja {cookiesPolicyLink}.
			Molemmat käytännöt ovat saatavillasi myös englanniksi, jotta voit
			tarkastella, arkistoida tai tulostaa niitä milloin tahansa.<br />
			{siteName} käyttää verkkosivustolla kolmannen osapuolen evästeitä. Saadaksesi lisätietoja
			tietoja verkossa käytettävien evästeiden tyypeistä {websiteLink}, niiden tarkoituksesta ja miten
			määrittääksesi selaimesi, jos et halua meidän käyttävän näitä evästeitä,
			käy osoitteessa {cookiesPolicyLink}.
		</p>
		<p>
			Molemmat käyttöehdot sekä {privacyPolicyLink} ja 
			{cookiesPolicyLink} on laadittu voimassa olevien määräysten mukaisesti
			sovellettavia säännöksiä, mm. palveluista annettu laki 34/2002
			Tietoyhteiskunta ja sähköinen kaupankäynti sekä asetus (EU) 2016/679
			Euroopan parlamentin ja neuvoston 27. huhtikuuta 2016 antaman lausunnon
			luonnollisten henkilöiden suojelua henkilötietojen käsittelyssä
			tiedot ja näiden tietojen vapaa liikkuvuus ja jolla direktiivi 95/46/EY
			kumotaan.
		</p>
		<h3>3. VERKKOSIVUSTON KÄYTTÖ JA HYVÄKSYMINEN</h3>
		<p>
			Pääsy Verkkosivustolle on ilmainen, lukuun ottamatta sen kustannuksiin liittyvää osaa
			Internetin tarjoaman tietoliikenneverkon kautta
			palveluntarjoaja, jonka kanssa olet sopinut. Voit selata verkkosivustoa vapaasti
			ja käytä sitä niin monta kertaa kuin haluat. Päästäksesi verkkosivustoon ja navigoidaksesi siellä,
			sinun ei tarvitse rekisteröityä, paitsi jos haluat vuokrata palvelun.
		</p>
		<p>
			Verkkosivuston käyttö antaa sinulle verkkosivuston käyttäjän tilan
			(jäljempänä "Käyttäjä") ja tarkoittaa, että hyväksyt sen täydellisesti ja varauksetta
			nämä käyttöehdot sekä {privacyPolicyLink} ja {cookiesPolicyLink}
			Verkkosivustolta. Lisäksi sitoudut olemaan käyttämättä Palvelua laittomiin
			tarkoituksiin.
		</p>
		<p>
			Siirrymällä verkkosivustolle ja selaamalla sitä, vakuutat omallasi
			vastuu siitä, että olet täysi-ikäinen ja että sinulla on tarvittavat lailliset vaatimukset
			kyky päästä verkkosivustolle ja käyttää sitä, vakuuttaen myös, että olet täysin
			ymmärtää ja hyväksyä nämä käyttöehdot varauksetta.
		</p>
		<p>
			Toisaalta ilmoitamme, että arkistoimme oikeudellisista syistä
			sähköiset asiakirjat, joissa ostot on virallistettu. Voit käyttää
			nämä asiakirjat milloin tahansa pyytämällä niitä osoitteessa: {supportLink}.
		</p>
		<h3>4. VERKKOSIVUSTON KÄYTTÖEHDOT</h3>
		<p>
			Käyttäjä sitoutuu käyttämään Verkkosivustoa näiden käyttöehtojen mukaisesti,
			voimassa oleva lainsäädäntö ja hyvässä uskossa. Siten Käyttäjä vastaa sivustolle {siteName}.
			 ja jollekin kolmannelle osapuolelle aiheutuneista vahingoista ja menetyksistä
			näiden ehtojen, lainsäädännön ja vilpittömän mielen vastaisesta käytöstä
			Verkkosivuston Käyttäjän toimesta.
		</p>
		<h3>5. PALVELUN KUVAUS</h3>
		<p>
			Palvelun kautta {siteName} sallii palvelun tilauksen
			suorittaa kuvankäsittelyn.
		</p>
		<p>
			Kieli, jolla {siteName} ja ostaja solmivat sopimuksen
			tehdään alkuperämaan.<br />
			Verkkopalvelussa ostoprosessi on seuraava:
		</p>
		<ol>
			<li>Sinun on rekisteröidyttävä verkkosivustolla käyttäjätunnuksella ja salasanalla.</li>
			<li>
				Rekisteröityessään käyttäjän on valittava yksi maksusuunnitelmista
				löytyy Hinnat-osiosta ja myönnetään hyvityksiä riippuen
				valittu suunnitelma. Jokaisella pisteellä voit muokata yhtä kuvaa.
			</li>
			<li>
				Palvelun ostamisen jälkeen käyttäjällä on hallinta
				paneeli, josta he löytävät:
				<ul>
					<li>
						Osio, jossa on luettelo kaikista käsitellyistä kuvista
						voi muokata sitä niin monta kertaa kuin haluat ja ladata sen omaan
						laite.
					</li>
					<li>
						Suunnitelmat ja maksut -osio, josta voit tarkastella laskuja ja peruuttaa
						tilaus.
					</li>
					<li>Oma tili -osio, jossa voit muuttaa tiliasetuksia.</li>
				</ul>
			</li>
		</ol>
		<p>
			Kun palvelun osto on tehty, sen vahvistaa
			lähettämällä sähköpostiviestin korkeintaan 24 tunnin kuluessa antamaasi osoitteeseen
			osoitettu. Se ilmoittaa palvelun, kuinka tilaus peruutetaan, sen
			summa, sovellettavat verot, maksutapa ja sovellettavat ehdot ja
			ehdot.
		</p>
		<h4>5.1 Tilaus</h4>
		<p>
			Palvelun tilaus vaihtelee valitun liittymän mukaan ja tulee olemaan
			uusitaan automaattisesti samaksi ajaksi sen päättymiseen asti.
			Jos et peruuta tilaustasi, valtuutat meidät lataamaan
			vastaava vuosimaksu maksutavallasi.
		</p>
		<p>
			Voit peruuttaa Palvelun tilauksesi milloin tahansa ja teet sen
			pääset käyttämään sitä vuosittaisen laskutuskauden loppuun asti. Vastaanottaja
			Lain sallimassa laajuudessa maksuja ei palauteta, emmekä tarjoa
			hyvitykset tai hyvitykset osittaisista vuositilausjaksoista.
		</p>
		<h3>6. HINTA JA VEROT</h3>
		<p>
			Sivustolla {siteName} tarjottavien tuotteiden hinnat on ilmoitettu euroina
			(€) tai sen maan valuutta, josta osto on tehty, Arvo
			Tuotteen hinnasta kannetaan ostohetkellä voimassa oleva arvonlisävero (alv).
			Tuotteet.
		</p>
		<p>
			Toiminta voi joka tapauksessa olla arvonlisäverosta vapautettu tai ei arvonlisäveron alainen
			asuinmaastasi tai olosuhteista, joissa toimit. Tästä syystä,
			joissakin tapauksissa tilauksen lopullista hintaa voidaan muuttaa suhteessa
			yksi näkyy.<br />
			Arvonlisäverosta vapautettujen tahojen tekemät ostot ilmoittavat tästä viimeistään
			lähettää ALV-/NIF-numeronsa sähköpostitse osoitteeseen {supportLink}, ei tallentamatta
			ostot mainitulla verolla.
		</p>
		<h3>7. MAKSUTAPA</h3>
		<p>
			Ostetun palvelun verkkomaksu voidaan suorittaa luotto- tai pankkikortilla.
			Tässä mielessä {siteName} ilmoittaa siitä luotto- ja maksukorttien haltijoille
			tapahtumat verkkokaupassa suoritetaan turvallisella maksulla
			yhdyskäytävä käyttäen SSL-tekniikkaa tiedonsiirron turvallisuuden takaamiseksi.
		</p>
		<h3>8. PERUUTUS- JA HYVITYSOIKEUS</h3>
		<h4>8.1. Peruuttamisoikeus</h4>
		<p>
			Ottaen huomioon verkkopalvelussamme markkinoidut tuotteet, ohjelmistot digitaalisessa muodossa
			QR-muodossa, peruutusoikeus ei ole voimassa
			16. marraskuuta 2007 annetun kuninkaallisen lain 1/2007 artiklan 103 kohdan m alakohta
			että yleisen kuluttajansuojalain tarkistettu teksti ja
			Käyttäjät ja muut täydentävät lait on hyväksytty.
		</p>
		<h4>8.2. Hyvitykset</h4>
		<p>
			Riippumatta käyttäjän valitsemasta sopimuksesta, käyttäjän maksamista summista ja
			lain sallimassa laajuudessa ei palauteta.
		</p>
		<p>
			Sopimuspalvelua ei saa luovuttaa tai siirtää muille käyttäjille
			palvelu.
		</p>
		<p>
			Joka tapauksessa käyttäjä voi käyttää sopimuspalvelua vuoden loppuun asti
			sopimusaika.
		</p>
		<h3>9. TARJOUSTEN VOIMASSAOLO</h3>
		<p>
			Palvelussa tarjotut palvelut ja niiden hinnat ovat saatavilla
			ostaa, kun ne ovat tämän kautta näytettävässä palveluluettelossa
			verkkosivusto.
		</p>
		<p>
			Joka tapauksessa {siteName} pidättää oikeuden tehdä muutoksia siihen
			Palvelussa sopivaksi katsomallaan tavalla pystyä päivittämään tuotteita ja palveluita
			markkinoista riippuen.
		</p>
		<p>
			{siteName} pidättää oikeuden muuttaa hintoja ilman ennakkoilmoitusta. Me
			ilmoittaa, että huolimatta hintoihin tehdyistä päivityksistä
			Palvelussa, ne voivat sisältää virheitä. Korjaamme viipymättä mahdolliset virheet
			näkyvät, mutta ne eivät sido Palvelua.
		</p>
		<h3>10. TURVALLISUUS</h3>
		<p>
			Kuten edellä mainittiin, koko ostoprosessi sekä lähetys
			henkilötietojesi ja maksujärjestelmien käsittely suoritetaan suojatulla sivulla ja
			salatulla tavalla SSL-protokollan kautta.
		</p>
		<p>
			Takaamme Palvelun turvallisuuden voimassa olevan ajan mukaisesti
			tekninen tietämys. {siteName} ei kuitenkaan voi taata täydellistä
			Palvelun tulevaisuuden turvallisuus. Joka tapauksessa lupaamme korjata ja
			toteuttaa asianmukaiset korjaavat toimenpiteet mahdollisen turvallisuuden korjaamiseksi
			rikkoa mahdollisimman pian.
		</p>
		<p>
			Suostut ilmoittamaan asiasta sivustolle {siteName} välittömästi ja sähköpostitse {supportLink}
			kaikista tilanteista, jotka voivat johtaa toisena henkilönä esiintymiseen.
		</p>
		<h3>11. MUUTOKSET JA TYÖMÄTÖS</h3>
		<p>
			Saatamme päivittää Palvelun ehtoja myös tulevaisuudessa
			kuin itse Palvelun ominaisuudet ja toiminnot.
		</p>
		<p>
			Ilmoitamme ehtojen muutoksista ilmoittamalla
			näkyvällä paikalla verkkosivuillamme ja/tai sähköpostitse.
		</p>
		<p>
			Jos jokin näiden ehtojen sisältämä lauseke ilmoitetaan, kokonaan tai
			osittain, mitätön tai tehoton, se vaikuttaa vain mainittuun säännökseen tai osaan
			se on mitätön tai tehoton. Ehdot pysyvät voimassa
			kaikki muu, jolla on tällainen säännös, tai se osa siitä, johon se vaikuttaa
			ei ole sijoitettu.
		</p>
		<h3>12. SOPIMUKSISTA JOHTAVAT VAATIMUKSET JA TOIMENPITEET</h3>
		<p>
			Tämä palvelu on mahdollisuuksien mukaan Espanjan lain alainen.<br />
			Yksinkertaistaakseen vaateiden ratkaisemista siviilioikeudellisilla menettelyillä ja
			vähentää kustannuksia, emme sulje pois mahdollisuutta alistua
			Kauppakamareiden välitystuomioistuimen pääomavälitys ja
			Ala. Tässä mielessä ja sovellettavien määräysten mukaisesti
			 {siteName} ilmoittaa eurooppalaisesta verkkokiistanratkaisusta
			foorumi, joka helpottaa tällaisten riitojen ratkaisemista tuomioistuinten ulkopuolella
			myös verkossa solmittuja sopimuksia kuluttajien ja Internet-palvelun välillä
			tarjoajat. Tätä alustaa voi käyttää seuraavan verkkosivuston kautta:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. IMMATERIAALI- JA TEOLLISUUSOIKEUDET</h3>
		<p>
			Verkkosivusto ja sen sisältö ovat suojan alaisia
			voimassa olevat kansalliset immateriaali- ja/tai teollisoikeuksia koskevat määräykset, kuten
			sekä niihin sovellettavia kansainvälisiä yleissopimuksia sovellettaessa
			asioita. {siteName} on kaiken omistaja tai hänellä on asianmukainen käyttöoikeus
			Immateriaali- ja teollisoikeudet verkkosivustoon ja sen sisältöön.
		</p>
		<p>
			Kaikenlainen jäljentäminen, jakelu, julkinen viestintä, muuntaminen,
			saataville asettaminen ja yleensä kaikki muu hyväksikäyttö
			Verkkosivuston tai sen sisällön kaupallisiin tarkoituksiin ilman ennakkoilmoitusta
			{siteName}:n nimenomainen suostumus. On nimenomaisesti kiellettyä poistaa
			tunnistaa sivuston {siteName} tiedot Intellektuaalin ja
			Sivuston tai sen sisällön teollisoikeudet.
		</p>
		<p>
			{siteName} pidättää kaikki immateriaali- ja teollisoikeudet
			Verkkosivustosta ja sen sisällöstä, varaamalla myös lainkäyttöön
			sitä vastaavat toimet minkä tahansa lopettamiseksi, estämiseksi tai syytteeseen asettamiseksi
			Verkkosivuston tai sen sisällön laiton käyttö. Ei missään tapauksessa ja alle ei
			olosuhteet pääsevät Verkkosivustolle tai käyttävät sitä Käyttäjän tai kolmannen toimesta
			osapuolet muodostavat tai tarkoittavat minkä tahansa {siteName}:n toimeksiannon
			verkkosivuston tai sen sisällön immateriaali- tai teollisoikeudet.
			Missään tapauksessa {siteName} ei ole vaatinut lopettamaan sivuston käytön
			Verkkosivusto tai sen laiton tai näiden ehtojen vastainen sisältö voi olla
			ymmärretään {siteName}:n hiljaiseksi suostumukseksi tällaisiin tarkoituksiin tai luopumuksena
			sitä mahdollisesti vastaavien oikeudellisten toimien toteuttamisesta.
		</p>
		<h3>14. VASTUUT JA TAKUUT</h3>
		<p>
			Käyttäjän tulee käyttää Verkkosivustoa ja sen sisältöä ohjeiden mukaisesti
			näiden käyttöehtojen määräykset, voimassa oleva lainsäädäntö ja hyvässä uskossa. Minkä tahansa
			verkkosivuston tai sen sisällön käyttö näiden yleisten ehtojen vastaisesti,
			laki tai hyvässä uskossa on nimenomaisesti kielletty, riippumatta siitä, onko kyseinen käyttö sitä tehnyt
			taloudellinen tarkoitus vai ei.<br />
			Käyttäjä on vastuussa kaikista sivustolle {siteName} aiheutuneista vahingoista.
			 tai kolmansille osapuolille suoraan tai epäsuorasti mistä tahansa käytöstä
			jonka Käyttäjä tekee Verkkosivustosta tai sen sisällöstä näiden vastaisesti
			ehdot, laki, moraali, yleinen järjestys tai hyvä usko.
		</p>
		<p>
			Jotta Verkkosivusto ja sen sisältö ovat käyttäjän saatavilla, {siteName}
			 vaatii kolmansien osapuolten tarjoamia palveluita. Onko mahdollista että
			huolimatta {siteName}:n pyrkimyksistä pitää verkkosivusto saatavilla
			ja käyttäjien saatavilla, sen saatavuus voidaan keskeyttää, keskeyttää tai
			peruutettu muista syistä kuin {siteName}. Siksi {siteName}
			ei takaa, että pääsyssä ei esiinny keskeytyksiä tai virheitä
			Verkkosivusto tai sen sisältö eikä se, että niitä päivitetään tai näytetään aina
			heidän uusin versio. Tästä syystä {siteName} hylkää kaikki
			vastuu vahingoista, jotka voivat aiheutua Käyttäjälle tai kolmansille osapuolille
			keskeytyksen, keskeytyksen, jatkuvuuden puutteen, verkkokatkoksen seurauksena
			tai Verkkosivuston katkaiseminen.
		</p>
		<p>
			{siteName} ei ole missään tapauksessa eikä missään olosuhteissa vastuussa
			vahingot tai tappiot, jotka aiheutuvat käyttäjälle syistä, jotka eivät johdu sivustosta {siteName}
			 kuten esimerkinomaisesti eikä missään tapauksessa rajoittavasti luonnollinen
			katastrofit, ylivoimaiset esteet tai äärimmäisen kiireelliset tilanteet, virukset, haitalliset
			komponentit, selaimen toimintahäiriöt, verkkokatkot, tietomurrot tai
			kolmannen osapuolen hyökkäyksiä.
		</p>
		<h3>15. LINKIT</h3>
		<p>
			Verkkosivustot, alustat, foorumit, chatit, blogit tai ulkoiset sosiaaliset verkostot, jotka
			linkin tai linkin verkkosivustolle on ilmoitettava selvästi, että heillä ei ole
			sivuston {siteName} valtuutus tai valvonta ja mainittu linkitys tai
			linkki ei sisällä, oleta tai tarkoita minkäänlaista yhteyttä sivuston {siteName} välillä
			 ja verkkosivustot, alustat, foorumit, chatit, blogit tai ulkoiset
			sosiaaliset verkostot, jotka linkittävät verkkosivustoon tai linkittävät siihen.
		</p>
		<p>
			Joka tapauksessa kaikki linkit, jotka on tarkoitettu verkkosivustolle, on suunnattava
			suoraan verkkosivuston kotisivulle tai kotisivulle napsauttamalla URL-osoitetta
			verkkosivustosta, joka kattaa kotisivun tai aloitussivun koko näytön
			Verkkosivustolle, jotta linkki on ehdoton ja täydellinen ilman käyttöä
			kehyksiä, kehyksiä tai hyperlinkkejä. {siteName} ei vastaa missään tapauksessa
			ja missään olosuhteissa siihen liittyvään sisältöön, tietoihin tai tietoihin
			verkkosivusto, sen sisältö tai mikä tahansa muu verkkosivustoilla, alustoilla oleva asia,
			foorumit, keskustelut, blogit tai kolmannen osapuolen sosiaaliset verkostot, joissa on linkki tai linkki
			Verkkosivusto.
		</p>
		<p>
			On nimenomaisesti kiellettyä linkittää tai linkittää verkkosivustolle verkkosivustoilta,
			alustat, foorumit, chatit, blogit tai sosiaaliset verkostot lain tai moraalin vastaisesti
			ja hyvät tavat, erityisesti pornografiset, laittomat, laittomat tai
			ihmisoikeuksia loukkaavaa sisältöä.
		</p>
		<p>
			Toisaalta Verkkosivusto voi sisältää linkkejä kolmansien osapuolien verkkosivustoille,
			alustat, foorumit, chatit, blogit tai sosiaaliset verkostot. {siteName} ei
			heillä on inhimilliset ja/tai tekniset keinot tietää tai hallita tietoja ja
			sisältöä, joka näkyy kolmannen osapuolen verkkosivustoilla. Siksi {siteName} ei missään tapauksessa
			 olla vastuussa linkitettyjen sivustojen sisällöstä ja nro
			olosuhteiden mukaan mainittuja linkkejä voidaan pitää tehokkaana sisällön tuntemisena
			sivustoista, joihin ne linkittävät.
		</p>
		<h3>16. TIETOSUOJA</h3>
		<p>
			Kuten kohdassa {privacyPolicyLink} on määritelty, {siteName} sitoutuu käyttämään Käyttäjää
			tietoja, kunnioittaa niiden luottamuksellisuutta ja käyttää niitä määräysten mukaisesti
			hoidon tarkoitukseen sekä noudattaakseen velvollisuuttaan säilyttää se.
			ja mukauttaa kaikki toimenpiteet muuttamisen, katoamisen, käsittelyn tai luvattomuuden välttämiseksi
			pääsy voimassa olevan lainsäädännön säännösten mukaisesti
			henkilötietojen suojaa.
		</p>
		<p>
			Verkkosivusto sisältää asianmukaiset suojatoimenpiteet ja käyttää alan standardeja
			teknologia parantaa turvallisuutta, eheyttä, täydellisyyttä, tarkkuutta ja
			keräämiensä ja vahvistamiensa henkilötietojen suojaa
			kohtuulliset varotoimet näiden tietojen suojaamiseksi mahdolliselta katoamiselta tai
			väärinkäyttö. Sen tietosuojaa ja turvallisuutta koskevia sääntöjä tarkistetaan säännöllisesti
			ja parannellaan tarvittaessa, ja se pyrkii varmistamaan, että vain valtuutetut
			henkilöillä on pääsy käyttäjän antamiin tietoihin.
		</p>
		<p>
			Lisätietoja {siteName}:n hallinnoinnista ja hoidosta
			 tiedoistasi, lue {privacyPolicyLink} ja {cookiesPolicyLink}.
		</p>
		<h3>17. KESTO JA MUUTOKSET</h3>
		<p>
			Nämä käyttöehdot ovat voimassa niin kauan kuin ne ovat alttiina
			käyttäjille, jotta heti kun niitä muutetaan tai päivitetään kokonaan tai osittain,
			nämä ehdot lakkaavat olemasta voimassa, koska ne ovat uusia käyttöehtoja
			ne, jotka säätelevät verkkosivuston käyttöä.
		</p>
		<p>
			{siteName} pidättää oikeuden tarkistaa, muokata tai päivittää näitä
			käyttöehdot milloin tahansa. Jos näissä olosuhteissa tapahtuu muutoksia
			käytöstä mistä tahansa syystä, {siteName} ilmoittaa käyttäjille sivuston etusivulla
			Internetissä mainitusta seikasta, jotta he saavat asianmukaisesti tietoa ja voivat kuulla
			nykyisten käyttöehtojen tarkistukset, muutokset tai päivitykset
			tyytyväisyytesi.
		</p>
		<h3>18. YLEISTÄ</h3>
		<p>
			Missään tapauksessa ja missään olosuhteissa ei saa olla käyttämättä oikeuksiaan
			jonka {siteName} on ymmärtänyt luopumisena niistä.
		</p>
		<p>
			Näiden ehtojen sisältämät otsikot ovat vain suuntaa antavia tai
			informatiivisia, jotta ne eivät vaikuta, täsmennä tai laajenna tulkintaa
			siitä.
		</p>
		<p>
			Siinä tapauksessa, että jokin näiden ehtojen sisältämistä lausekkeista olisi
			tuomioistuin on julistanut mitättömäksi, loukkaavaksi tai täytäntöönpanokelvottomaksi kokonaan tai osittain
			tai hallintoelin, mainittu ilmoitus vaikuttaa lausekkeeseen erikseen
			kyseessä olevasta, pitäen sitä ei-toivotuksi ja ilman mitättömyyttä, väärinkäyttöä tai
			soveltumattomuus ulotetaan missään olosuhteissa koskemaan muuta
			olosuhteet, jotka säilyvät.
		</p>
		<p>
			Nämä käyttöehdot sekä {privacyPolicyLink} ja {cookiesPolicyLink}
			niitä säätelevät kaikkina aikoina Espanjan nykyiset määräykset.
		</p>
		<h3>19. ASIAKASPALVELU</h3>
		<p>
			Selvennyksiä, tapauksia tai vaatimuksia varten voit ottaa meihin yhteyttä:<br />
			Sähköposti: {supportLink}<br />
			Postiosoite: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Espanja.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Viimeksi päivitetty: 10. kesäkuuta 2024',
		content: `
			<h3>1. Vastuullinen osapuoli ja kuvaus</h3>
			<h5>1.1. Vastuullinen</h5>
			<p>Tämän sivuston käsittelystä vastaava henkilö on Remove Background S.L (jäljempänä Poista tausta 
			tai Palvelu), jonka osoite on Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Espanja.</p>
			<p>NIF: B56768260<br> Sähköposti: {supportLink}</p>

			<h5>1.2. Kuvaus</h5>
			<p>Taustan poistamisen tietosuojakäytännön (jäljempänä "tietosuojakäytäntö") hyväksyminen on välttämätön ehto 
				verkkosivustomme käyttöä ja palvelun tarjoamista varten (jäljempänä "Palvelu").<br>
				Tämä tietosuojakäytäntö säätelee henkilökohtaisten ja ei-henkilökohtaisten tietojesi keräämistä, käsittelyä ja käyttöä 
				Poista tausta -toiminnon käyttäjänä otsikossa näkyvästä voimaantulopäivästä alkaen.<br>
				Henkilötietojesi käsittelyssä Poista tausta noudattaa voimassa olevaa paikallista ja eurooppalaista lainsäädäntöä, 
				sekä sen täytäntöönpanoasetukset.</p>


			<h3>2. Kerätyt tiedot</h3>
			<p>Pääsy verkkosivustollemme voidaan tehdä ilman, että sinun tarvitsee antaa mitään tietoja, vaikka rekisteröityminen ja/ 
				tai tee sopimus suunnitelmistamme, sinun on annettava meille henkilökohtaisia tietoja. Tiedot (henkilökohtainen 
				tai ei-henkilökohtainen) Palvelun keräämä voi vaihdella sen perusteella.<br>
				Palvelun keräämät henkilökohtaiset ja ei-henkilökohtaiset tiedot tulevat meille kolmella tavalla: 1) se, mikä 
				kerätään automaattisesti 2) se, jonka annat meille vapaaehtoisesti, ja 3) se, mitä kolmannet osapuolet tarjoavat.</p>

			<h5>2.1. Kerätty automaattisesti</h5>
			<p>Tämä tieto koostuu seuraavista:</p>
			<ul>
				<li>Evästeiden tai vastaavien laitteellesi tallennettujen mekanismien avulla kerätty, aina suostumuksellasi tai sisään 
					muiden oikeusperustojen mukaisesti. Katso lisätietoja evästekäytännöstämme.</li>
				<li>IP-osoite, josta yhteys muodostetaan, käytetyn laitteen tyyppi ja sen ominaisuudet, versio 
					käyttöjärjestelmä, selaimen tyyppi, kieli, päivämäärä, maa, pyynnön aika, 
					muun muassa sen URL-osoite, josta tulet, URL-osoite, johon siirryt tai käyttämäsi mobiiliverkko.</li>
				<li>Palvelun käyttötiedot ja sen käytön aikana havaitut mahdolliset virheet.</li>
				<li>Lisäksi Remove Background käyttää Google Analyticsia, Google, LLC:n tarjoamaa analyyttistä palvelua. 
					kotipaikka Yhdysvalloissa ja pääkonttori osoitteessa 1600 Amphitheatre Parkway, Mountain View, California 94043. 
					Näiden palvelujen tarjoamiseksi he käyttävät evästeitä, jotka keräävät tietoja, mukaan lukien käyttäjän IP-osoite, 
					jotka Google lähettää, käsittelee ja tallentaa www.google.com-verkkosivustossa vahvistettujen ehtojen mukaisesti. 
					Mukaan lukien mainittujen tietojen mahdollinen siirtäminen kolmansille osapuolille lakisääteisistä syistä tai 
					kun kolmannet osapuolet käsittelevät tietoja Googlen puolesta.</li>
			</ul>
			<p>Voit joka tapauksessa poistaa Google Analyticsin evästeet käytöstä <a href="{externalLink: disableGoogleAnalyticsLink}">täältä</a>.</p>

			<h5>2.2. jonka annat vapaaehtoisesti</h5>
			<p>Tämä tieto koostuu seuraavista:</p>
			<ul>
				<li>Kaikki tiedot ovat pakollisia.</li>
				<li>Se, jota Remove Background vaatii rekisteröinnin viimeistelemiseksi verkossa: muun muassa etu- ja sukunimi, osoite ja sähköpostiosoite.</li>
				<li>Kaikki tiedot ovat pakollisia.</li>
				<li>Henkilökohtaiset tai muut tiedot palvelun sopimuksen tekemiseen, kuten sähköpostiosoitteesi ja luotto- tai maksukorttisi numero.</li>
				<li>Palvelussa perustettujen yhteys- tai mielipidekanavien kautta lähetetyt viestit voivat sisältää henkilökohtaisia tai ei-tietoja, 
					esimerkiksi nimesi ja sähköpostiosoitteesi.</li>
			</ul>

			<h5>2.3. Kolmansien osapuolten tarjoama</h5>
			<p>Tämä tieto koostuu seuraavista:</p>
			<ul>
				<li>Maksujärjestelmien tai luottokorttien käsittelijöiden tarjoama, kuten ostoajankohta tai sen summa.</li>
			</ul>


			<h3>3. Oikeudet ja tarkoitukset</h3>
			<p>Ilmoitamme, että lomakkeiden täyttäminen on vapaaehtoista. Jos et kuitenkaan täytä pakollisia kenttiä 
				(merkitty yleensä tähdellä), joidenkin Palvelun toimintojen käyttö ei ole mahdollista tai on rajoitettua.<br>
				Henkilötiedot, jotka annat meille, sisällytetään ja käsitellään Taustan poistamisen hoitotoimintojen rekisterissä 
				voidaksemme vastata pyyntöihisi, tarjota pyydettyä palvelua ja pitää sinut ajan tasalla toimintaan liittyvistä asioista 
				yrityksestä ja sen palveluista.<br>
				Voit milloin tahansa käyttää oikeuttasi saada pääsyä, korjata, poistaa tai rajoittaa hoitoasi, 
				vastustaa ja siirtää henkilötietojasi sähköpostitse osoitteeseen: {supportLink} tai postiosoitteeseen: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Espanja.<br>
				Molemmissa tapauksissa sinun on tunnistettava itsesi etu- ja sukunimelläsi sekä tarvittaessa kopio DNI- tai kansallisesta henkilöllisyystodistuksestasi.<br>
				Jos olet antanut suostumuksesi tiettyyn tarkoitukseen, sinulla on oikeus peruuttaa suostumus milloin tahansa, 
				vaikuttamatta sen peruuttamista edeltävään suostumukseen perustuvan hoidon laillisuuteen.<br>
				Lisäksi, jos arvelet, että Tapa, jolla Remove Background käsittelee tietojasi, on ongelma, 
				voit ohjata valituksensa vastaavalle <a href="{knowYourRightsLink}">tietosuojaviranomaiselle</a>, joka on <a href="{aepdLink}">Espanjan tietosuojavirasto</a> 
				Espanjan tapauksessa ilmoitettu.</p>


			<h3>4. Ikä</h3>
			<p>Verkkopalvelun käytön osalta vakuutat olevasi täysi-ikäinen ja että sinulla on tarvittavat lailliset 
				kyky sitoutua tähän sopimukseen ja käyttää sivustoa sen ehtojen mukaisesti, jotka sinä täysin 
				ymmärtää ja tunnustaa.<br>
				Vakuutat, että kaikki tiedot, jotka annat käyttääksesi Palvelua ennen sen käyttöä ja sen aikana, ovat oikeita ja täydellisiä 
				ja tarkka.</p>


			<h3>5. Tietojen käyttö</h3>
			<p>Taustan poistaminen käyttää kerättyjä tietoja:</p>
			<ul>
				<li>Hallinnoi ja päivitä Palvelua (oikeusperustana on oikeutettu etumme ylläpitää ja ylläpitää Palvelua). 
					ajan tasalla ja hyvässä kunnossa).</li>
				<li>Käynnistä esittämiäsi kysymyksiä (oikeusperustana on oikeutettu etumme vastata pyyntöihin ja 
					käyttäjiemme epäilykset).</li>
				<li>Käsittele suorittamasi maksut (sopimus on oikeusperusta).</li>
				<li>Tarjoa sopimuspalvelu (sopimus on oikeusperusta).</li>
				<li>Palvelun turvallisuuden ylläpitäminen, laittoman toiminnan tutkiminen, käyttöehtojemme noudattaminen ja
					auttaa valtion turvallisuusjoukkoja niiden mahdollisten tutkimusten yhteydessä (oikeudellinen perusta on meidän 
					oikeutettu etu palvelun ja sen käyttäjien turvallisuuden takaamiseen ja ylläpitämiseen).</li>
			</ul>
			<p>Taustan poistaminen ei käytä automaattisia päätöksiä, vaikka se voi luoda peruskäyttäjäprofiileja, 
				oikeusperustana on oikeutettu etumme kaupallisiin tarkoituksiin ja henkilökohtaisten tarjousten tarjoamiseen.<br>
				Poista tausta voi myös käyttää käyttäjätietoja koottujen ja anonyymien tietojen muodossa näyttääkseen niitä kolmansille osapuolille. 
				Voit myös jakaa tilastoja ja demografisia tietoja käyttäjistä ja heidän Palvelun käytöstään kolmansille osapuolille. 
				Nämä kolmannet osapuolet eivät kuitenkaan pysty tunnistamaan sinua henkilökohtaisesti.</p>

			<h5>5.1. Sähköposteissa ja yhteydenottolomakkeissa</h5>
			<p>Sivustolla on SSL-salaus, jonka avulla käyttäjä voi lähettää henkilötietonsa turvallisesti tavallisten yhteydenottolomakkeiden kautta.<br>
				Kerätyt henkilötiedot käsitellään automaattisesti ja sisällytetään vastaaviin tiedostoihin 
				käsittelytoimintojen tietueesta ja jonka omistaja on Poista tausta.</p>
			<p>Tässä mielessä:</p>
			<ul>
				<li>Saamme IP-osoitteesi, jota käytetään viestin alkuperän tarkistamiseen, jotta voimme tarjota sinulle 
					suosituksia (esimerkiksi tietojen esittäminen oikealla kielellä) ja mahdollisten sääntöjenvastaisuuksien havaitsemiseksi 
					(esimerkiksi mahdolliset kyberhyökkäysyritykset Palveluun) sekä Internet-palveluntarjoajaasi liittyvät tiedot.</li>
				<li>Voit myös antaa meille tietosi puhelimitse, sähköpostitse tai muilla ilmoitetuilla viestintätapoilla.</li>
			</ul>
			<p>Käytetyt maksutavat:</p>
			<ul>
				<li>Maksupalveluntarjoajamme maksavat palveluistamme luotto- tai pankkikortteja. 
					Palvelulla tai sen henkilökunnalla ei ole koskaan pääsyä pankkitietoihin (esimerkiksi luottokortin numeroon) 
					jonka käyttäjä asiakkaana toimittaa näille kolmansille osapuolille.</li>
			</ul>


			<h3>6. Tietojen säilyttäminen</h3>
			<p>Alla on ilmoitettu, kuinka kauan Palvelun käsittelemiä tietoja säilytetään:</p>
			<ul>
				<li>Eritellyt tiedot säilytetään ilman poistoaikaa.</li>
				<li>
					Asiakastietoja säilytetään niin kauan kuin on tarpeen, ja niitä voidaan säilyttää, kunnes:
					<ul>
						<li>5 vuotta, art. 1964 siviililaki (henkilökohtaiset kanteet ilman erityistä määräaikaa).</li>
						<li>6 vuotta, art. 30 kauppalain (esimerkiksi kirjanpitokirjat tai laskut).</li>
					</ul>
				</li>
				<li>Käyttäjätietoja säilytetään enintään 12 kuukautta, jotta he voivat vastata pyyntöihinsä.</li>
			</ul>


			<h3>7. Kolmansien osapuolten kanssa jaetut tiedot</h3>
			<p>On olemassa kolmansia osapuolia, jotka hallinnoivat osaa Palvelusta.<br>
				Poista tausta edellyttää, että he noudattavat tätä tietosuojakäytäntöä soveltuvin osin sen lisäksi, että heillä on oma. Poista tausta ei kuitenkaan ole vastuussa mainitun käytännön noudattamisesta.<br>
				Joissain olosuhteissa Poista tausta voi jakaa, käyttää tai säilyttää kolmansille osapuolille mitä tahansa kerättyjä henkilökohtaisia tietoja:</p>
			<ul>
				<li>Palvelun tarjoaminen:</li>
			</ul>
			<p>Palveluntarjoajat, jotka suorittavat toimintoja puolestamme, kuten maksupalveluita, verkkopalveluita, yritysanalytiikkaa, asiakaspalvelua tai verkkomarkkinointia. Nämä palveluntarjoajat voivat kerätä ja saada käyttöönsä tietoja, joita ne tarvitsevat tehtäviensä suorittamiseksi, mutta he eivät saa jakaa tai käyttää tietoja mihinkään muuhun tarkoitukseen.</p>
			<ul>
				<li>Yhteistyö toimivaltaisten viranomaisten kanssa:</li>
			</ul>
			<p>Jos uskomme, että se on kohtuudella välttämätöntä lain, oikeusprosessin tai oikeutetun edun noudattamiseksi. Joka tapauksessa annamme vain ehdottoman vaaditut tiedot.</p>


			<h3>8. Turvatoimet</h3>
			<p>Remove Background ottaa käyttöön kaikki tarvittavat tekniset ja organisatoriset toimenpiteet
				suojella kerättyjen henkilökohtaisten ja ei-henkilökohtaisten tietojen turvallisuutta ja koskemattomuutta. 
				Sekä luvaton pääsyn että sen tahattoman muuttamisen, katoamisen tai tuhoutumisen estämiseksi.<br>
				Joka tapauksessa Poista tausta ei voi taata kerättyjen tietojen täydellistä turvallisuutta, 
				joten sinun on aina tehtävä yhteistyötä ja käytettävä maalaisjärkeä jaettavien tietojen suhteen.<br>
				Ymmärrät ja hyväksyt, että henkilökohtaisia ja ei-henkilökohtaisia tietoja saattaa esiintyä myös poistamisen jälkeen 
				jää näkyviin välimuistiin tai jos muut käyttäjät ovat kopioineet tai tallentaneet sen.</p>


			<h3>9. Muutokset tietosuojakäytäntöön</h3>
			<p>Saamme päivittää tätä tietosuojakäytäntöä tulevaisuudessa. Ilmoitamme sen muutoksista lähettämällä ilmoituksen annettuun sähköpostiosoitteeseen ja/tai sijoittamalla ilmoituksen näkyvälle paikalle verkkosivuillamme.</p>


			<h3>10. Ota yhteyttä</h3>
			<p>Jos sinulla on kysyttävää tästä tietosuojakäytännöstä, ota meihin yhteyttä osoitteessa:</p>
			<p>Sähköposti: {supportLink}<br> 
				Osoite: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Espanja.</p>
		`
	},
	gdpr: {
		lastUpdate: 'Viimeksi päivitetty: 10. kesäkuuta 2024',
		content: `
			<h3>1. Kuka on vastuussa ja miten heihin ottaa yhteyttä?</h3>
			<p>Tämän sivuston rekisterinpitäjä on Remove Background S.L, jonka osoite on Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Espanja.</p>
			<p>Voit ottaa häneen yhteyttä sähköpostitse osoitteessa {supportLink}.</p>

			<h3>2. Mitä tietoja kerätään?</h3>
			<p>
				Keräämme automaattisesti tietoja laitteellesi lataamiemme evästeiden kautta, mukaan lukien analytiikka. 
				Keräämme myös IP:n, josta yhteys muodostetaan, käytetyn laitteen tyypin ja sen ominaisuudet, 
				käyttöjärjestelmän versio, selaimen tyyppi, kieli, päivämäärä, maa, pyynnön aika, 
				URL-osoite, josta tulet, URL-osoite, johon siirryt, tai käytetty mobiiliverkko, muun muassa.<br>
				Käyttäjä antaa meille vapaaehtoisesti joitakin tietoja, kuten nimensä ja sukunimensä, sähköpostiosoitteensa tai pankkitietonsa 
				jotta voit ottaa meihin yhteyttä, rekisteröityä palveluun tai ostaa tilauksen.
			</p>

			<h3>3. Mihin kerättyjä tietoja käytetään?</h3>
			<p>
				Palvelu käyttää kerättyjä tietoja mm. palvelun hallinnointiin ja päivittämiseen, pyyntöihisi vastaamiseen, 
				lähettää sinulle uutiskirjeemme ja kampanjatarjouksemme sähköpostitse, hallita rekisteröitymistäsi alustalle, hallita ja tarjota 
				liittymääsi liittyvät palvelut, käsittelemään suorittamasi maksut ja laatimaan vastaavat laskut, 
				ylläpitää Palvelun turvallisuutta, tutkia laitonta toimintaa, valvoa käyttöehtojamme ja 
				auttaa valtion turvallisuusjoukkoja ja elimiä niiden mahdollisissa tutkimuksissa.
			</p>

			<h3>4. Kuinka kauan niitä säilytetään?</h3>
			<ul>
				<li>Eritellyt tiedot säilytetään ilman poistoaikaa.</li>
				<li>
					Asiakastietoja säilytetään niin kauan kuin on tarpeen, ja niitä voidaan säilyttää, kunnes:
					<ul>
						<li>5 vuotta, art. 1964 siviililaki (henkilökohtaiset kanteet ilman erityistä määräaikaa).</li>
						<li>6 vuotta, art. 30 kauppalain (esimerkiksi kirjanpitokirjat tai lasku).</li>
					</ul>
				</li>
				<li>Käyttäjän tietoja säilytetään enintään 12 kuukautta, jotta he voivat vastata pyyntöihinsä.</li>
				<li>Palvelun sosiaalisten verkostojen sivuille ja profiileihin lataamat käyttäjätiedot säilytetään siitä hetkestä lähtien, kun käyttäjä antaa suostumuksensa siihen asti, kun hän peruuttaa sen.</li>
			</ul>

			<h3>5. Mitkä ovat oikeutesi käyttäjänä?</h3>

			<p>
				Tietosuojaoikeus: Asianomaisella osapuolella on oikeus saada rekisterinpitäjältä vahvistus siitä, onko 
				tai häntä koskevia henkilötietoja ei käsitellä.
			</p>
			<p>
				Oikeus oikaisuun: Asianomaisella osapuolella on oikeus saada ilman aiheetonta viivytystä rekisterinpitäjältä 
				henkilötietojen oikaisu, jotka ovat epätarkkoja ja vaikuttavat suoraan häneen. Samoin asianosainen tekee sen 
				on oikeus täydentää puutteellisia henkilötietoja, mukaan lukien lisäselvitys.
			</p>
			<p>
				Poistooikeus: Asianosaisella on oikeus saada ilman aiheetonta viivytystä rekisterinpitäjältä poisto 
				häntä koskevista henkilötiedoista.
			</p>
			<p>
				Oikeus rajoittaa tietojen käsittelyä: tarkoittaa sitä, että vastuuhenkilö rajoittaa tietojesi käsittelyä, 
				vaikka sen harjoittamisessa on kaksi näkökohtaa: 1) Kun kyseenalaistat henkilötietojesi tarkkuuden, aikana, joka mahdollistaa 
				sen tarkistamisesta vastaava henkilö ja 2) kun olet vastustanut henkilötietojesi käsittelyä, 
				suorittaa oikeutetun edun tai yleisen edun mukaisen tehtävän perusteella, kun taas vastuuhenkilö tarkistaa, ovatko nämä syyt 
				voittaa sinun.
			</p>
			<p>
				Oikeus tietojen siirrettävyyteen: Asianosaisella on oikeus saada häntä koskevat henkilötiedot, 
				jonka hän on toimittanut rekisterinpitäjälle jäsennellyssä muodossa, yleiseen käyttöön ja mekaanisesti luettavaan, ja 
				siirtää ne toiselle rekisterinpitäjälle ilman, että rekisterinpitäjä, jolle ne on toimitettu, estäisi niitä.
			</p>
			<p>
				Tässä mielessä asianomaisella on oikeus saada henkilötiedot suoraan rekisterinpitäjältä 
				ohjaimelle, kun se on teknisesti mahdollista.
			</p>

			<h3>6. Kuinka voit käyttää oikeuksiasi?</h3>

			<p>
				Voit käyttää henkilötietooikeuksiasi milloin tahansa lähettämällä sähköpostin osoitteeseen: {supportLink} Tai postiosoitteeseen: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Espanja. Molemmissa tapauksissa sinun tulee tunnistaa itsesi etu- ja sukunimelläsi, 
				sekä tarvittaessa kopio DNI- tai kansallisesta henkilötodistuksestasi.<br>
				Lisäksi, jos arvelet, että Tapa, jolla Remove Background käsittelee tietojasi, on ongelma, voit ohjata vaatimuksiasi 
				vastaavalle <a href="{knowYourRightsLink}">tietosuojaviranomaiselle</a>, joka on <a href="{aepdLink}">Espanjan tietosuojavirasto</a> 
				Espanjan tapauksessa.
			</p>

			<h3>7. Onko turvatoimenpiteitä toteutettu?</h3>
			<p>
				Palvelu toteuttaa kaikki tarvittavat tekniset ja organisatoriset toimenpiteet suojellakseen henkilöiden turvallisuutta ja koskemattomuutta 
				ja ei-henkilökohtaisia kerättyjä tietoja. Sekä luvaton pääsyn että vahingossa tapahtuvan muuttamisen, katoamisen tai tuhoutumisen estämiseksi.<br>
				Joka tapauksessa Palvelu ei voi taata kerättyjen tietojen ehdotonta turvallisuutta, joten sinun on tehtävä yhteistyötä ja 
				käytä maalaisjärkeä jaettujen tietojen suhteen.<br>
				Ymmärrät ja hyväksyt, että henkilökohtaiset ja ei-henkilökohtaiset tiedot saattavat jäädä katseltaviksi välimuistissa tai poistamisen jälkeen. 
				jos muut käyttäjät ovat kopioineet tai tallentaneet ne.
			</p>

			<h3>8. Onko olemassa henkilötietojen siirtoja vai kansainvälisiä siirtoja?</h3>

			<p>
				Emme siirrä tietoja tai kansainvälisiä siirtoja. On kuitenkin olemassa kolmansia osapuolia, jotka hallinnoivat osaa Palvelusta 
				joita vaadimme noudattamaan tietosuojakäytäntöämme siltä osin kuin se koskee heitä ja että heillä on omansa. 
				Nämä kolmannet osapuolet ovat palveluntarjoajia, jotka suorittavat toimintoja puolestamme, kuten web hosting, 
				analytiikan seurantaa tai verkkokehitystä.<br>
				Myös, jos uskomme, että se on kohtuudella välttämätöntä jonkin lain, oikeusprosessin tai oikeutetun edun täyttämiseksi. 
				Joka tapauksessa annamme vain ehdottoman vaaditut tiedot.
			</p>
		`
	},
	cookiesPolicy: {
		lastUpdate: 'Viimeksi päivitetty: 21. kesäkuuta 2024',
		content: `
			<h3>Yhteenveto</h3>
			<ul>
			    <li>Käytetyt evästeet: <strong>Omat ja kolmannet osapuolet</strong></li>
			    <li>Käytetäänkö niitä tilastojen hankkimiseen? <strong>Kyllä, oikeutetun etujemme perusteella palvelun parempaa hallintaa kohtaan.</strong></li>
			    <li>Kolmannen osapuolen palvelut, jotka asentavat evästeitä tämän verkkosivuston kautta: <strong>Google, Google Analytics, Cloudflare ja Stripe.</strong></li>
			</ul>

			<h3>Evästeiden määrittäminen ja poistaminen käytöstä</h3>
			<p>
			    Voit sallia, estää tai poistaa laitteellesi asennetut evästeet verkkoselaimestasi. Jos et salli evästeiden asentamista laitteellesi, 
			    selauskokemus voi huonontua. Alta löydät ohjeet evästeiden määrittämiseen kussakin selaimessa:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Reuna</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Ooppera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Tyypit ja käyttötarkoitukset</h3>
			<p>Palvelu käyttää omia ja kolmannen osapuolen evästeitä parantaakseen selaamista, tarjotakseen palvelua ja hankkiakseen tilastoja verkkosivuston käytöstä.</p>

			<h3>2. Mikä eväste on ja mihin sitä käytetään?</h3>
			<p>
			    Eväste on tekstitiedosto, joka lähetetään tietokoneellesi, matkapuhelimeesi tai tablet-laitteen verkkoselaimeen ja jota käytetään tallentamaan ja hakemaan tietoja
			    selaus tehty. Esimerkiksi muistaaksesi käyttäjätunnuksesi ja salasanasi tai profiiliasetuksesi.
			</p>

			<h3>3. Millaisia evästeitä on olemassa?</h3>
			<p>Sen mukaan, kuka niitä hallinnoi:</p>
			<ul>
			    <li>Omat evästeet; ne lähetetään selaimeesi omista laitteistamme tai verkkotunnuksistamme.</li>
			    <li>Kolmannen osapuolen evästeet; ne lähetetään selaimellesi laitteista tai verkkotunnuksista, joita emme suoraan hallinnoi, vaan kolmannelta taholta, kuten Googlelta.</li>
			</ul>
			<p>Sen perusteella, kuinka kauan ne ovat aktiivisia, on olemassa:</p>
			<ul>
			    <li>Istunnon evästeet; ne säilyvät selaimesi evästetiedostossa, kunnes poistut verkkosivustolta, joten mikään ei jää laitteellesi.</li>
			    <li>Pysyvät evästeet; ne pysyvät laitteessasi ja verkkosivustomme lukee ne aina, kun teet uuden vierailun. Nämä evästeet lakkaavat toimimasta tietyn päivämäärän jälkeen.</li>
			</ul>
			<p>Lopuksi, niiden tarkoituksen mukaan, meillä on:</p>
			<ul>
			    <li>Tekniset evästeet; ne parantavat selaamista ja verkkosivuston asianmukaista toimintaa.</li>
			    <li>Personointievästeet; ne mahdollistavat pääsyn palveluun ennalta määritetyillä ominaisuuksilla useiden kriteerien perusteella.</li>
			    <li>Analytics-evästeet; niiden avulla voidaan mitata ja tilastollisesti analysoida tarjotun palvelun käyttöä.</li>
			</ul>
			<p>Luettelo sivuston <strong>remove-background.com</strong></p> käyttämistä kolmannen osapuolen evästeistä
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: Heidän evästeensä (NID tai CONSENT) mahdollistavat mainosten näyttämisen personoinnin Googlen ulkopuolella tai tietojen tallentamisen
			        kuten ensisijainen kieli hakutulosten näyttämisessä.<br><a href="{externalLink: googleCookieTypes}">Lisätietoja</a> evästetyypeistä, joita Google käyttää eri palveluissaan.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: Niiden evästeiden (kuten _ga) avulla voidaan laskea, kuinka monta kertaa käyttäjä vierailee verkkosivustolla, miten, milloin ja mistä.<br>
			        Joka tapauksessa voit poistaa Google Analyticsin evästeet käytöstä <a href="{externalLink: disableGoogleAnalytics}">täältä</a>.
			    </li>
			    <li>Cloudflare: Saat lisätietoja Cloudflaren evästekäytännöstä ja -käytöstä napsauttamalla <a href="{externalLink: cloudflareCookiesPolicy}">tätä linkkiä</a>.</li>
			    <li>Stripe: Löydät <a href="{externalLink: stripeCookiesPolicy}">täältä</a> tietoa Stripen evästekäytännöstä ja käytöstä.</li>
			</ul>
		`
	}
};
